// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const SuccessIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="SuccessIcon" ref={forwardedRef} {...props}>
      <path d="m8.504 13.5 5.657-5.657-1.062-1.061-4.596 4.596L7.09 9.964l-1.061 1.061z" />
      <path d="M2 10a8 8 0 1 0 16 0 8 8 0 0 0-16 0m8 6.5a6.5 6.5 0 1 1 0-13 6.5 6.5 0 0 1 0 13" />
    </SvgIcon>
  );
});

/**
 * Use when something went well
 * @public
 */
export const SuccessIcon = /* @__PURE__ */ Object.assign(SuccessIconComponent, {
  displayName: 'SuccessIcon',
});
